import { useMediaQuery } from 'react-responsive';
import Chat from './Chat'; // your original
import MobileChatView from './MobileChatView';

const ChatRouter = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 }); // adjust breakpoint if needed

  return isMobile ? <MobileChatView /> : <Chat />;
};

export default ChatRouter;
